import axios from "axios";
import { fetchToken } from "./API";

const BackendApiBaseUrl = process.env.REACT_APP_API_URL;
const inviteTrackingInvitesURL = `${BackendApiBaseUrl}/invite-tracking/invites`;

const buildQuery = (params) =>
  Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

export const getInviteTrackingInvitesApi = async (request = {}) => {
  const headers = await fetchToken();
  const query = buildQuery({
    page: request?.page || 1,
    limit: request?.limit || 10,
    search: request?.search || request?.query,
    status:
      request?.status && request.status !== "all" ? request.status : undefined,
  });

  return axios.get(`${inviteTrackingInvitesURL}?${query}`, { headers });
};

export const getInviteTrackingInviteHistoryApi = async ({
  profileId,
  jobId,
}) => {
  const headers = await fetchToken();
  if (!profileId || !jobId) return null;

  return axios.get(`${inviteTrackingInvitesURL}/${profileId}/${jobId}`, {
    headers,
  });
};
